
import { Component, Vue } from 'vue-property-decorator';
import InputField from '@/ts/InputField';
import { InputValidators } from '@/ts/store/Constants';

@Component
export default class InputFieldMethods extends Vue {
    public inputs: { [inputId: string]: InputField } = {};
    public textInputElement: HTMLTextAreaElement = null;
    public allowedImagesMimes: string[] = ['image/png', 'image/jpg', 'image/jpeg'];

    get InputValidators() {
        return InputValidators;
    }

    public checkFileMime(fileMime: string): boolean {
        return this.allowedImagesMimes.includes(fileMime);
    }

    public handleFocus(event: any): void {
        if (this.inputs[event.target.id] instanceof InputField) {
            this.inputs[event.target.id].focused = true;
        }

        return;
    }

    public handleBlur(event: any): void {
        if (this.inputs[event.target.id] instanceof InputField) {
            this.inputs[event.target.id].focused = false;
        }

        return;
    }

    public isFocused(inputId: string): boolean {
        if (!(this.inputs[inputId] instanceof InputField)) {
            return false;
        }

        return this.inputs[inputId].focused;
    }

    public setInputFieldHeight(includeInnerSpacing: boolean = true, reset: boolean = false) {
        this.textInputElement.style.height = 'inherit';

        if (reset) {
            return;
        }

        // Get the computed styles for the element
        const computed = window.getComputedStyle(this.textInputElement);

        // Calculate the height
        let height = parseInt(computed.getPropertyValue('border-top-width'), 10)
            + parseInt(computed.getPropertyValue('padding-top'), 10)
            + this.textInputElement.scrollHeight
            + parseInt(computed.getPropertyValue('padding-bottom'), 10)
            + parseInt(computed.getPropertyValue('border-bottom-width'), 10) + 1;

        if (!includeInnerSpacing) {
            height = this.textInputElement.scrollHeight;
        }

        this.textInputElement.style.height = height + 'px';
    }
}
